import script from "./StudentRewardHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentRewardHistory.vue?vue&type=script&setup=true&lang=js"

import "./StudentRewardHistory.vue?vue&type=style&index=0&id=67653cc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67653cc0"]])

export default __exports__